import BaseComposedChart from "../../sisu/chart/BaseComposedChart.sisu"

const NeoComposedChart = (props)=>{
    return <BaseComposedChart {...props}>
        {props.children}
    </BaseComposedChart>
}

export default NeoComposedChart;